module.exports = __webpack_public_path__ + "static/media/award1.89243a01.png";